import { defineMessages } from "react-intl";
const messages = defineMessages({
    spaceEmailSentSuccess: {
        id: "app.spaces.actions.email.success.text",
        defaultMessage: "Email sent successfully.",
    },
    spaceEmailTitle: {
        id: "app.spaces.actions.email.title.text",
        defaultMessage: "Email This Space",
    },
    spaceEmailButton: {
        id: "app.spaces.actions.email.button.text",
        defaultMessage: "Send Email",
    },
    spaceEmailSendButton: {
        id: "app.spaces.actions.email.send.button.text",
        defaultMessage: "Send Email",
    },
    spaceEmailFormSendMeCopy: {
        id: "app.spaces.actions.email.form.sendMeCopy.text",
        defaultMessage: "Send me a copy of this message",
    },
    spaceEmailFormProspect: {
        id: "app.spaces.actions.email.form.prospect.text",
        defaultMessage: "Email Address",
    },
    spaceEmailFormCustomMessage: {
        id: "app.spaces.actions.email.form.customMessage.text",
        defaultMessage: "Custom Message",
    },
    spaceEmailProspectError: {
        id: "app.spaces.actions.email.form.prospect.error.text",
        defaultMessage: "Email address is required.",
    },
    spaceEmailCustomMessageError: {
        id: "app.spaces.actions.email.form.customMessage.error.text",
        defaultMessage: "Custom Message is required.",
    },
});
export default messages;
